import { InvalidOperationError } from './invalidOperation.error';
export class Ok {
    #value;
    ok = true;
    get error() {
        return undefined;
    }
    constructor(v) {
        this.#value = v;
        this.ok = true;
    }
    unwrap() {
        return this.#value;
    }
    unwrapOr() {
        return this.#value;
    }
    unwrapOrElse() {
        return this.#value;
    }
    expect() {
        return this.#value;
    }
    match(cases) {
        return cases.ok(this.#value);
    }
}
export class Fail {
    error;
    ok;
    constructor(err) {
        if (!err) {
            throw new InvalidOperationError('A failing result needs to contain an error');
        }
        this.error = err;
        this.ok = false;
    }
    unwrap() {
        throw this.error;
    }
    unwrapOr(v) {
        return v;
    }
    unwrapOrElse(fn) {
        return fn(this.error);
    }
    expect(err) {
        throw err;
    }
    match(cases) {
        return cases.err(this.error);
    }
}
//# sourceMappingURL=value.js.map